export const suppliersSliceName = "suppliers"
